module.exports = __webpack_public_path__ + "site/img/serviceszh.932f1b1f.png";